import AuthActivateContainer from './AuthActivateContainer';
import ActivateConnector from './Connector/Apollo/Activate/ActivateConnectorApollo';

const AuthActivatePage = () => {
  return (
    <ActivateConnector>
      {({ ...activateAccount }) => <AuthActivateContainer {...activateAccount} />}
    </ActivateConnector>
  );
};

export default AuthActivatePage;
